import React from 'react';

const About = () => {
  return (
    <div>
      About Page Details
    </div>
  )
}

export default About;